/* eslint-disable no-unused-vars */
import axios from 'axios';
import moment from 'moment';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/records/files`;

const state = {
    files: [],
    unsorted_files: [],
};

const getters = {
    allRecordFiles: state => state.files,
    allUnsortedRecords: state => state.unsorted_files,
};

const actions = {
    async fetchFiles({ commit }, folderId) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}?record_folder_id=${folderId}`, {
                headers: { 'x-drmms-token': authToken }
            });
            let files = [];

            files = response.data.records.map((file) => ({
                ...file,
                nrecord_date: moment(file.record_date).format('LLL'),
                date: moment(file.createdAt).format('LLL'),
            }))
            console.log(files);
            commit('setFiles', files);
            return true;
        } catch (err) {
            console.log(err);
        }
    },
    async deleteFile({ commit }, recordId) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.delete(`${url}/delete/${recordId}`, {
                headers: { 'x-drmms-token': authToken }
            });
            commit('removeFile', recordId);
        } catch (err) {
            console.log(err);
        }
    },
    async fetchUnsortedFiles({ commit }) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}/all/unsorted`, {
                headers: { 'x-drmms-token': authToken }
            });
            let files = [];
            
            files = response.data.rows.map((file) => ({
                ...file,
                nrecord_date: moment(file.record_date).format('LLL'),
                date: moment(file.createdAt).format('LLL'),
            }))
            commit('setUnsortedFiles', files);
            return response.data;
        } catch (err) {
            console.log(err);
        }
    }
};

const mutations = {
    setFiles: (state, files) => (state.files = files),
    setUnsortedFiles: (state, files) => (state.unsorted_files = files),
    removeFile: (state, id) => state.files = state.files.filter(file => file.id !== id),
};

export default {
    state,
    getters,
    actions,
    mutations,
}